module.exports = __webpack_public_path__ + "assets/img/b7f44cb7de3e7e2c7333ae267a5f81f7.svg";